module.exports = __webpack_public_path__ + "static/img/2.d5096738.png";